import type { UserRole } from '../api/client';

export type RouteName =
  | 'home' | 'design' | 'editor' | 'result' | 'tryon' | 'booking-location' | 'artist-select' | 'artist-profile'
  | 'booking-date' | 'booking-time' | 'booking-review' | 'booking-success' | 'offer' | 'b2b-form' | 'reveal' | 'privacy'
  | 'admin-dashboard' | 'admin-leads' | 'admin-lead' | 'admin-requests' | 'admin-request' | 'admin-artists' | 'admin-designs' | 'admin-team' | 'admin-settings';

export interface AppRoute { name: RouteName; id?: string }

export function roleLanding(role: UserRole, appMode: 'demo' | 'normal' = 'normal'): AppRoute {
  if (appMode === 'demo') return { name: 'home' };
  return role === 'admin' || role === 'owner' ? { name: 'admin-dashboard' } : { name: 'home' };
}

export function resolveDeepRoute(search: string, startParam: string, role: UserRole, appMode: 'demo' | 'normal' = 'normal'): AppRoute {
  const params = new URLSearchParams(search);
  const view = params.get('view') || '';
  if (view === 'offer' || startParam === 'b2b') return { name: 'offer' };
  if (view === 'admin' && (role === 'admin' || role === 'owner')) return { name: 'admin-dashboard' };
  if (view === 'reveal' && params.get('sessionId')) return { name: 'reveal', id: params.get('sessionId') || undefined };
  const adminRequest = startParam.match(/^admin_request_([a-zA-Z0-9_-]{2,48})$/);
  if (adminRequest && (role === 'admin' || role === 'owner')) return { name: 'admin-request', id: adminRequest[1] };
  const tryon = startParam.match(/^tryon_([a-zA-Z0-9_-]{2,56})$/);
  if (tryon) return { name: 'tryon', id: tryon[1] };
  return roleLanding(role, appMode);
}

export function canOpenAdmin(route: AppRoute, role: UserRole): boolean {
  return !route.name.startsWith('admin-') || role === 'admin' || role === 'owner';
}
